import { EventBus } from "../../../eventbus";

export default {
  props: {
    activeProcess: Object,
  },
  data() {
    return {
      showSnackbarItems: false,
    };
  },
  computed: {
    progress() {
      return this.activeProcess ? this.activeProcess.progress : null;
    },
  },
  methods: {
    handleToggleShow() {
      this.showSnackbarItems = !this.showSnackbarItems;
      EventBus.$emit(`mobile-snackbar--set-show`, this.showSnackbarItems);
    },
  },
  watch: {
    activeProcess() {
      if (!this.activeProcess) {
        this.showSnackbarItems = false;
        EventBus.$emit(`mobile-snackbar--set-show`, this.showSnackbarItems);
      }
    },
  },
};
